import parse from "html-react-parser";
import { useMediaQuery } from "react-responsive";
import ImageSlider from "./ImageSlider";

const ImageSliderItem = (props) => {

    const { imageArray, title, textArray, layout, imagePosition, speed, size, animated, modern } = props // layout > row y column; side > before y after

    const isMobile = useMediaQuery({ maxWidth: 1280 })

    if (isMobile)
        return (
            <section className="flex w100 white-bkg">
                <section className="main-middle-section-mobile">

                    {
                        (imagePosition === "before") ?
                            <ImageSlider imageArray={imageArray || []} speed={speed || "normal"} size={size || "normal"} animated={animated}/> : <></>
                    }

                    <section className="main-middle-subsection-mobile">
                        <h2 className="middle-section-title">{title}</h2>
                        {
                            (textArray?.map((t, index) => {
                                return (<article key={index}>{parse(t)}</article>)
                            }))
                        }
                    </section>

                    {
                        (imagePosition === "after") ?
                            <ImageSlider imageArray={imageArray || []} speed={speed || "normal"} size={size || "normal"} animated={animated}/> : <></>
                    }
                </section>
            </section>
        )
    else
        return (
            <section className="flex w100 white-bkg">
                <section className={`${(layout === "column") ? "flex col acenter jcenter pad-30 main-middle-section-2 " : "flex  acenter jcenter pad-30 main-middle-section-2"}${modern ? " modern-content-row" : ""}`}>

                    {
                        (imagePosition === "before") ?
                            <ImageSlider imageArray={imageArray || []} speed={speed || "normal"} size={size || "normal"} animated={animated}/> : <></>
                    }

                    <section className={`main-middle-subsection-2 w100${modern ? " modern-content-card" : ""}`}>
                        <h2 className="middle-section-title">{title}</h2>
                        {
                            (textArray?.map((t, index) => {
                                return (<article key={index}>{parse(t)}</article>)
                            }))
                        }
                    </section>

                    {
                        (imagePosition === "after") ?
                            <ImageSlider imageArray={imageArray || []} speed={speed || "normal"} size={size || "normal"} animated={animated}/> : <></>
                    }
                </section>
            </section>
        )



}

export default ImageSliderItem